export const BASE_URI = '/content/api';
export const BASE_URI_DEVELOPMENT_CENTER = `${BASE_URI}/development-center`;
export const BASE_URI_FILES = `${BASE_URI}/files`;
